<div
  class="tile-content"
  [ngClass]="{ 'is-active': tile.isActive }"
  (click)="actionClick()"
  data-cy="territory-tile"
>
  <div class="text">
    <div class="title">{{ tile.title | translate }}</div>
    <div class="value" [ngClass]="tile.color">{{ tile.value }}</div>
  </div>
  <div class="arrow" *ngIf="showLink">
    <ion-icon
      name="chevron-forward-outline"
      data-cy="territory-tile-arrow"
    ></ion-icon>
  </div>
</div>
